import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { GestureConfig } from "@angular/material";
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";

import { InMemoryWebApiModule } from "angular-in-memory-web-api";
import { InMemoryDataService } from "./shared/inmemory-db/inmemory-db.service";

import { rootRouterConfig } from "./app.routing";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";

import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { environment } from "./../environments/environment.prod";
import { ConfigModule } from "ngx-envconfig";
import { WaveModalComponent } from "./shared/components/wave-modal/wave-modal.component";
import { SafePipe } from "./shared/pipes/safe.pipe";

import { DeviceDetectorModule } from 'ngx-device-detector';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    PerfectScrollbarModule,
    // ngx-envconfig
    // ConfigModule.forRoot({state: 'developpement'}),
    ConfigModule.forRoot({ state: environment.state }),
    DeviceDetectorModule.forRoot(),

    // Logger
    // LoggerModule.forRoot({serverLoggingUrl: environment.serverLoggingUrl, level: NgxLoggerLevel.OFF, serverLogLevel: NgxLoggerLevel.OFF}),
    LoggerModule.forRoot({
      level:
        environment.state === "production"
          ? NgxLoggerLevel.TRACE
          : environment.state === "developpement"
          ? NgxLoggerLevel.TRACE
          : NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.OFF,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    InMemoryWebApiModule.forRoot(InMemoryDataService, {
      passThruUnknownUrl: true,
    }),
    RouterModule.forRoot(rootRouterConfig, { useHash: false }),
  ],
  declarations: [AppComponent],
  entryComponents:[WaveModalComponent],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
